
const localStorage = 
{
}

export default localStorage


// WEBPACK FOOTER //
// ./src/utils/localStorageUtils.js